module.exports = __webpack_public_path__ + "fonts/ABCGintoVCA-Regular.d3458752.otf";